"use strict";

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPromise = function (_Promise) {
  (0, _inherits3.default)(JPromise, _Promise);

  function JPromise() {
    var _ref;

    (0, _classCallCheck3.default)(this, JPromise);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // 调用父类的constructor

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = JPromise.__proto__ || (0, _getPrototypeOf2.default)(JPromise)).call.apply(_ref, [this].concat(args)));

    if (_this.__proto__) {
      _this.__proto__.fail = _this.__proto__.catch;
      _this.__proto__.always = _this.__proto__.finally;
    }
    return _this;
  }

  return JPromise;
}(_promise2.default);

module.exports = JPromise;